import { CurrencySchema } from '@eigtech/currency';
import { z } from 'zod';
import { BillSchema, PaidBillSchema } from '../base/index.js';
import { ServiceEventBaseSchema, serviceEventType } from './service.js';
export const invoicingBillEventType = (eventName) => serviceEventType('bill', eventName);
export const BillEventTypeSchema = z.enum(['created', 'paymentMade', 'updated']);
export const BillEventType = BillEventTypeSchema.enum;
export const BillingEventSchema = ServiceEventBaseSchema.merge(z.object({
    type: invoicingBillEventType(),
    bill: BillSchema,
    metadata: ServiceEventBaseSchema.shape.metadata.and(z.object({
        requestActor: z.string().optional(),
    })),
}));
export const BillCreatedEventSchema = BillingEventSchema.merge(z.object({
    type: invoicingBillEventType(BillEventType.created),
}));
export const BillPaymentMadeEventSchema = BillingEventSchema.merge(z.object({
    type: invoicingBillEventType(BillEventType.paymentMade),
    bill: PaidBillSchema.merge(z.object({
        amountPaid: CurrencySchema,
        paymentDate: z.string().datetime(),
    })),
}));
export const BillUpdatedEventSchema = BillingEventSchema.merge(z.object({
    type: invoicingBillEventType(BillEventType.updated),
    bill: BillSchema.merge(z.object({
        updatedDate: z.string().datetime(),
    })),
}));
export const BillEventSchema = z.union([
    BillCreatedEventSchema,
    BillPaymentMadeEventSchema,
    BillUpdatedEventSchema,
]);
